var _rect, _g, _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownSlightRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.06318637043728 85.97965985523854",
    width: 118.12637274087456,
    height: 171.95931971047708,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 59.06318637043728,
    height: 85.97965985523854,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.27047617704784 11.423856016369541) rotate(0 19.065337422934135 32.45161009990767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.9 -0.25 C-0.32 5.37, -3.68 23.91, 2.76 34.59 C9.21 45.27, 31.93 58.85, 37.79 63.81 M0.82 -1.42 C1.38 4.28, -3.8 24.86, 2.21 35.85 C8.21 46.85, 30.86 59.67, 36.85 64.56",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.27047617704784 11.423856016369541) rotate(0 19.065337422934135 32.45161009990767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.23 58.53 C19.28 61.38, 24.23 61.02, 36.85 64.56 M14.23 58.53 C19.03 59.39, 23.46 61.57, 36.85 64.56",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.27047617704784 11.423856016369541) rotate(0 19.065337422934135 32.45161009990767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4 45.4 C26.35 51.33, 29.1 54.12, 36.85 64.56 M23.4 45.4 C26.26 48.96, 28.78 53.89, 36.85 64.56",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSlightRight);
export default __webpack_public_path__ + "static/media/arrowDownSlightRight.643b74af725c1b0a56d4c7345d425b83.svg";
export { ForwardRef as ReactComponent };